// ── Office készlet-kép URL feloldása (tiszta, tesztelhető) ───────────────────
// A telefon-készlet képei az office rendszerből jönnek; a böngésző KÖZVETLENÜL
// az office hostról tölti őket egy <img> taggel (nem a backend-proxyn át).
// Ezért a nyers mezőből egy VALÓBAN betölthető, HTTPS URL-t kell képezni.
//
// Kezelt esetek (a korábbi resolver ezeken elhasalt → emoji-fallback → „nincs kép”):
//   - image_url a gyökéren (új office formátum), fallback image[0].preview (régi).
//   - abszolút URL változatlan, DE http:// → https:// az office hoston
//     (különben a HTTPS oldalon mixed-content miatt a böngésző blokkolja).
//   - protokoll-relatív (//host/kep.jpg) → https:
//   - relatív útvonal elé OFFICE_HOST; a hiányzó „/” pótolva (a leggyakoribb hiba).
//   - üres string / whitespace / nem-string → null (emoji-fallback, nem törött kép).

export const OFFICE_HOST = 'https://office.norbiphone.hu';

export const resolveImageUrl = (d) => {
  if (!d) return null;
  let raw = d.image_url || (d.image && d.image[0] && d.image[0].preview) || null;
  if (typeof raw !== 'string') return null;
  raw = raw.trim();
  if (!raw) return null;

  // Abszolút URL: változatlan, de az office-hoston http→https (mixed-content).
  if (/^https?:\/\//i.test(raw)) {
    return raw.replace(/^http:\/\/(office\.norbiphone\.hu)/i, 'https://$1');
  }
  // Protokoll-relatív (//host/...) → https.
  if (raw.startsWith('//')) return `https:${raw}`;
  // Relatív útvonal: OFFICE_HOST elé, hiányzó „/” pótlásával.
  return `${OFFICE_HOST}${raw.startsWith('/') ? '' : '/'}${raw}`;
};
